<form (ngSubmit)="next()" [formGroup]="form">
    <div class="cp5" fxLayout="row wrap" fxLayoutAlign="flex-start center">
        <div *ngIf="getlang() == 'fr'" fxFlex="100" fxFlex.lt-md="100">
            <app-select-acheteur-public
                    #s
                    (object)="getobject($event)"
                    [control]="get('instNm')"
                    [withfiltre]="true"
            ></app-select-acheteur-public>
        </div>
        <div *ngIf="getlang() == 'ar'" fxFlex="100" fxFlex.lt-md="100">
            <app-select-acheteur-public
                    #s
                    (object)="getobject($event)"
                    [control]="get('instNmAr')"
                    [withfiltre]="true"
            ></app-select-acheteur-public>
        </div>
        <div *ngIf="getlang() == 'en'" fxFlex="100" fxFlex.lt-md="100">
            <app-select-acheteur-public
                    #s
                    (object)="getobject($event)"
                    [control]="get('instNmEn')"
                    [withfiltre]="true"
            ></app-select-acheteur-public>
        </div>
        <div *ngIf="getlang() != 'fr'" fxFlex="50" fxFlex.lt-md="100">
            <app-text-field

                    [control]="get('instNm')"
                    [label]="'nom_achteur_FR'"
            ></app-text-field>
        </div>

        <div *ngIf="getlang() != 'ar'" fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('instNmAr')"
                    [label]="'nom_achteur_ar'"
            ></app-text-field>
        </div>

        <div *ngIf="getlang() != 'en'" fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('instNmEn')"
                    [label]="'nom_achteur_en'"
            ></app-text-field>
        </div>
        <div fxFlex fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('instNmAbbr')"
                    [label]="'abb_achteur_fr'"
            ></app-text-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('instNmAbbrAr')"
                    [label]="'abb_achteur_ar'"
            ></app-text-field>
        </div>
        <div fxFlex fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('instNmAbbrEn')"
                    [label]="'abb_achteur_en'"
            ></app-text-field>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100">
            <app-select-common
                    [code]="commmCode.Type_acheteur"
                    [control]="get('instCl')"
                    [label]="'type_acheteur'"
            ></app-select-common>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-select-common
                    [code]="commmCode.Division"
                    [control]="get('areaCl')"
                    [label]="'division'"
            ></app-select-common>
        </div>
        <div fxFlex="33" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('taxId')"
                    [label]="'matricule_fiscale'"
            ></app-text-field>
        </div>
        <div fxFlex="33" fxFlex.lt-md="100">
            <app-text-field

                    [control]="get('poCd')"
                    [label]="'code_marchand'"
            ></app-text-field>
        </div>
        <div fxFlex fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('affilie')"
                    [label]="'affile'"
            ></app-text-field>
        </div>
        <div fxFlex="100" fxFlex.lt-md="100">
            <app-select-codepostal
                #sele
                [controladrese]="get('addr1')"
                [controlcode]="get('postCd')"
                [delegation]="sele?.selectDelegationComponent?.mat?.value"
                [gouvernorat]="sele?.selectGouvernoratComponent?.matselcet?.value"
                [ville]="sele?.selectVilleBygouvandDelComponent?.matselect?.value"
            ></app-select-codepostal>
        </div>

        <div fxFlex="100" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('addr2')"
                    [label]="'adress2'"
            ></app-text-field>
        </div>
        <!--    codepostal &&adresse -->

        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('chfNm')"
                    [label]="'nom_premier_resp'"
            ></app-text-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('chfPosition')"
                    [label]="'fonction_premier_resp'"
            ></app-text-field>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('hpage')"
                    [label]="'site_web'"
            ></app-text-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('email')"
                    [label]="'email'"
            ></app-text-field>
        </div>
    </div>
    <div fxLayoutAlign="end end" mat-dialog-actions>
        <app-spinner-container>
            <button color="primary" mat-raised-button>
                <span translate>submit</span>
            </button>
        </app-spinner-container>
    </div>
</form>
